import { render } from "./ShopingCart.vue?vue&type=template&id=19da0b4e"
import script from "./ShopingCart.vue?vue&type=script&lang=js"
export * from "./ShopingCart.vue?vue&type=script&lang=js"

import exportComponent from "D:\\xampp\\htdocs\\bdroyelfrontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__